const e = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: {
    type: { default: "messengerCard" },
    canvas: {},
    text: { default: "" },
    messenger_app_id: { default: "" },
    uri: { default: "" }
  },
  toDOM() {
    return ["div"];
  }
};
export {
  e as messengerCardSpec
};
